module.exports = __webpack_public_path__ + "static/media/Governmnet college 1950s.e12e8305.jpg";